export default "__VITE_ASSET__b61a58bf__"